import { buildSectionUrl, getSectionInnerHTML } from './utils';
import { Modal as PDPDialog } from '../../components/Modal';
import { Share } from '../../components/ShareButton';
import { nativeShare } from '../../components/ShareButton/native';

function getSectionToRender() {
  return {
    id: 'pdp-share-modal',
    section: 'pdp-share',
    selector: '.shopify-section',
  };
}

const share = () => {
  async function shareClickHandle(e) {
    const button = e.currentTarget;
    const productTitle = button.getAttribute('data-product-title');
    const sectionToRender = getSectionToRender();

    const shareData = {
      title: productTitle,
      url: window.location.href,
    };

    const isShared = await nativeShare(shareData);
    if (isShared) {
      return;
    }

    const url = buildSectionUrl([sectionToRender]);

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Response error is not okay');
        }
        return response.json();
      })
      .then((data) => {
        const dialogObj = new PDPDialog(sectionToRender.id);
        dialogObj.setContent(getSectionInnerHTML(data[sectionToRender.section], sectionToRender.selector)).show();

        // Defer this block because they are not user-visible tasks
        setTimeout(() => {
          const shareInstance = new Share(dialogObj.node.querySelector('.pdp-c-share'));
          shareInstance.setContent(shareData.url).init();

          dialogObj.setClose(() => shareInstance.close());
        }, 0);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  document.querySelector('.pdp-c-atc-header__share-btn').addEventListener('click', shareClickHandle);
};

export default share;
